import React from "react";
import { REFERRAL_PATH } from "utils/constants/paths";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";

const Referral = Loadable(React.lazy(() => import("./View")));

export const ReferralRoute: IRouteItem = {
  path: REFERRAL_PATH,
  element: React.createElement(Referral),
  name: "Referral",
  accessKeys: ["SuperAdmin", "Admin", "ContentManager"],
};
